"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EvmChainResolver = void 0;
var CommonEvmUtilsConfig_1 = require("./config/CommonEvmUtilsConfig");
var dataTypes_1 = require("./dataTypes");
var EvmChainResolver = /** @class */ (function () {
    function EvmChainResolver() {
    }
    EvmChainResolver.resolve = function (chain, core) {
        if (chain) {
            return dataTypes_1.EvmChain.create(chain, core);
        }
        var defaultEvmChain = core.config.get(CommonEvmUtilsConfig_1.CommonEvmUtilsConfig.defaultEvmApiChain);
        return dataTypes_1.EvmChain.create(defaultEvmChain, core);
    };
    return EvmChainResolver;
}());
exports.EvmChainResolver = EvmChainResolver;
//# sourceMappingURL=EvmChainResolver.js.map